module.exports = __webpack_public_path__ + "static/bowlIcon-30cd7b5a49e146c6acd3514bfce0613a.png";